module.exports = __webpack_public_path__ + "static/img/banner-textx.5a65b27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner-textx.png
// module id = zghA
// module chunks = 1